import { render, staticRenderFns } from "./backup.vue?vue&type=template&id=2e7e4eca&"
import script from "./backup.vue?vue&type=script&lang=js&"
export * from "./backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports